<template>
  <div class="mvh-40">
    <preloader v-if="!order.Order" v-bind:title="localize('loading_order')"></preloader>
    <div class="container mt-2xl" v-else>
        
        <router-link class="flex align-baseline line-1" to="/">
          <i v-if="locale!='HE'" class="fal fa-chevron-left mr-xs"></i>
          <span>{{localize('back_to_dashboard')}}</span>
          <i v-if="locale=='HE'" class="fal fa-chevron-left mr-xs"></i>
        </router-link>
        

      <h3 class="tcenter my-2xl">
        <strong>{{localize('order_review')}}</strong>
        <span
          v-if="order.Order.Order_header"
          v-text="' - ' + order.Order.Order_header"
        ></span>
        <span
          class="note ml-s"
          v-text="
            isClinic
              ? `(${orderUser.ClinicName} (${orderUser.ClinicBranch}) Clinic)`
              : `(Dr. ${orderUser.FirstName} ${orderUser.LastName})`
          "
        ></span>

        <a
          v-if="orderFile && orderFile.FileProccessingTypeId"
          :title="orderFile.OriginFileName"
          :class="[
            orderFile.FileProccessingTypeId === 3 ? 'disabled' : '',
            'block',
            'mt-s',
            'note',
            'mx-auto'
          ]"
          :href="`${serverAPI}mflow/OrderFileDownload/${orderFile.FileID}`"
        >          
          <span>{{localize('download_review')}}</span>
          <i v-if="locale=='HE'" class="fal fa-chevron-left fa-xs mr-xs"></i>
          <i v-if="locale!='HE'" class="fal fa-chevron-right fa-xs ml-xs"></i>
        </a>
      </h3>

      <div v-if="awaitingApproval" class="my-xl p-l bg-gray-2 clearfix">
        <h4 class="font-md pb-xl">
          <span>{{localize('surgical_plan_approval')}}</span>
          <a
            v-if="surgicalPlan"
            class="note ml-s"
            :href="`${serverAPI}mflow/OrderFileDownload/${surgicalPlan.FileID}`"
            target="_blank"
            >{{localize('view_surgical_plan')}}</a
          >
        </h4>
        <div class="check-group">
          <form-field
            class="flex stretch"
            field-type="checkbox"
            v-bind:label="localize('i_confirm_attached_approve_plans')"
            v-model="confirmation"
            required
            external-label
          ></form-field>
        </div>
        <span v-if="dirtyApproval && !confirmation" class="err text-red-2 note"
          >* {{localize('please_check_the_confirmation_checkbox')}}</span
        >

        <button @click="approveOrder" class="btn btn-primary right">
          <i
            :class="[
              'fal',
              'inl',
              loadingApproval ? 'fa-spin fa-spinner' : 'fa-check-circle'
            ]"
          ></i>
          <span class="ml-s">{{localize('approve_this_order')}}</span>
        </button>
      </div>
      <div class="flex flex-wrap justify-between _30-65">
        <div>
          <h4 class="text-blue font-rg">
            <span>{{localize('case_info')}}</span>
          </h4>
          <div v-if="order.Order.Order_header" :class="['review-field',getLangDir]">
            <span>{{localize('order_title')}}:</span>
            <span v-text="order.Order.Order_header"></span>
          </div>
          <div v-if="order.Order.Cust_name" :class="['review-field',getLangDir]">
            <span>{{localize('patient_identification')}}:</span>
            <span v-text="order.Order.Cust_name"></span>
          </div>
          <div v-if="order.Order.Order_date" :class="['review-field',getLangDir]">
            <span>{{localize('order_creation_date')}}:</span>
            <span v-text="formatDate(order.Order.Order_date)"></span>
          </div>
          <div v-if="order.Order.Actual_implant_date" :class="['review-field',getLangDir]">
            <span>{{localize('surgery_planned_date')}}:</span>
            <span v-text="formatDate(order.Order.Actual_implant_date)"></span>
          </div>
          <div
            v-if="order.Order.MlabStoneModelTrackingNumber"
            :class="['review-field',getLangDir]"
          >
            <span>{{localize('stone_model_tracking_no')}}:</span>
            <span v-text="order.Order.MlabStoneModelTrackingNumber"></span>
          </div>
          <div
            v-if="order.Order.MlabImpressionTrackingNumber"
            :class="['review-field',getLangDir]"
          >
            <span>Impression tracking No.:</span>
            <span v-text="order.Order.MlabImpressionTrackingNumber"></span>
          </div>
          <div :class="['review-field',getLangDir]" v-if="order.Order.comment">
            <span>{{localize('additional_notes')}}:</span>
            <span v-text="order.Order.comment"></span>
          </div>

          <div v-if="uploadedFiles.length" :class="['review-field files-list',getLangDir]" >
            <span>{{localize('files_uploaded')}}:</span>
            <ul>
              <li
                class="flex align-center"
                v-for="file in uploadedFiles"
                :key="file.FileName"
              >
                <a
                  v-if="file && file.FileProccessingTypeId"
                  :title="file.OriginFileName"
                  :class="[file.FileProccessingTypeId === 3 ? 'disabled' : '']"
                  :href="`${serverAPI}mflow/OrderFileDownload/${file.FileID}`"
                >
                  <i class="fal fa-file mx-xs"></i>
                  <span v-text="file.OriginFileName"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="teeth-chart-wrap mb-xl" v-if="teeth.selected.length">
          <teeth-chart
            :method="teeth.method"
            :selected-data="teeth.selected"
            display-mode
          ></teeth-chart>
          <h4 class="text-blue font-rg mt-xl">{{localize('clinical_indications')}}</h4>
          <div v-for="(tooth, i) in teeth.selected" :key="tooth.id">
            <!-- v-show="tooth.opt !== 1" -->
            <field-group
              :key="tooth.id"
              :count="teeth.selected.length"
              :group-index="i"
              :tooth-data="parseToothNumber(tooth)"
              :fields="implantLocationFields"
              :value="order.ImplantLocations[i]"
              display-mode
            ></field-group>
          </div>
          <div :class="['review-field',getLangDir]">
            <span>{{localize('procedure_type')}}: </span>
            <span v-text="fetchLabel(order.Order.AdditionalIndicationsTypeID,orderOptions.AdditionalIndicationsTypes)"></span>
          </div>
          <div :class="['review-field',getLangDir]">
            <!-- v-if="order.Order.MguideSupportType" -->
            <span>{{localize('support_type')}}:</span>
            <span v-text="fetchLabel(order.Order.MguideSupportType, supportTypes)"></span>
          </div>
          <div :class="['review-field',getLangDir]">
            <span>{{localize('fixation_pins')}}:</span>
            <span v-text="getFixationPinsText"></span>
          </div>

          <div
            v-if="
              order.OrderProstheticSolutionIDs &&
                order.OrderProstheticSolutionIDs.length
            "
            :class="['review-field',getLangDir]"
          >
            <span> {{localize('planned_prosthtic_otpions')}}</span>
            <ul class="mx-m">
              <li
                v-for="option in filteredProstheticSolutionTypes"
                :key="option.id"
                class=""
              >
                <span v-text="localize(option.name)"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import TeethChart from "@/components/TeethChart.vue";
import { storage } from "@/utils";

import { approve } from "@/services";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "ReviewOrder",
  data() {
    return {
      // Toggle at every step for validations...
      solicitNextStep: false,
      loading: false,
      confirmation: false,
      dirtyApproval: false,
      loadingApproval: false,
      supportTypes: [
        {id: 0,name: "Tooth-supported"},
        {id: 1,name: "Mucosa-supported"}
      ],
      teeth: {
        method: 0,
        selected: [],
        hasDigital: false,
        hasStoneModel: false,
        has3rdParty: false,
        hasImpressions: false
      },
      implantLocationDefaultObj: {},
      // mediaFileDefaultObj: {},
      order: {}
    };
  },
  mounted() {
    let orderOptions = storage.get("MFLOW__orderOptions", localStorage);
    if (!orderOptions) {
      this.initOrder(this);
    } else {
      this.initOrderOptions(JSON.parse(orderOptions));
    }
    this.initUpdateOrder();
  },
  components: {
    TeethChart
  },
  methods: {
    ...mapActions(["initOrder", "initOrderOptions", "initOrdersList"]),
    async approveOrder() {
      this.dirtyApproval = true;
      if (this.confirmation) {
        this.loadingApproval = true;
        await approve(this);
        this.loadingApproval = false;
        this.initOrdersList();
      }
    },
    formatDate(date) {
      return moment(date).format("D/M/YYYY");
    },
    fetchLabel(id, list, label = "name") 
    {      
       let labelText = _.find(list, { id })[label];
       labelText = labelText.toLowerCase();
       labelText = this.localize(labelText);
       console.log("fetchLabel() labelText >>> "+labelText);
       return labelText;
    },
    updateImplantLocations(e, payload, tooth, i) {
      this.order.ImplantLocations[i] = payload;
    },
    updateMethod(e) {
      this.teeth.method = e;
    },
    fetchToothById(ToothID) {
      let ToothTableItems = this.orderOptions.ToothTableItems;
      let findTooth = _.find(ToothTableItems, { ToothID });
      // console.log("FIND TOOTH >> ", findTooth);
      return findTooth;
    },
    parseToothNumber(tooth) {
      // Grab the Number by Method (ADA OR FDI)
      let method = this.teeth.method;
      let num = method === 1 ? "ADA" : "FDI";
      // console.log("PARSE TOOTH NUM:: TOOTH==", tooth);
      // console.log("PARSE TOOTH NUM:: NUM==", num);
      // console.log("PARSE TOOTH NUM:: METHOD==", method);
      // console.log("PARSE TOOTH NUM:: RESULT==", tooth[num]);
      return { ThoothID: tooth.id, num: tooth[num], TreatTypeID: tooth.opt };
    },
    fetchImplantIndex(tooth) {
      let i = _.findIndex(this.teeth.selected, { id: tooth.id });
      // console.log("implant index >", i);
      return i;
    },
    orderError(msg) {
      this.$router.push("/");
      this.$toasted.show(msg, {
        position: "bottom-center",
        // iconPack: "fontawesome",
        type: "warning",
        theme: "bubble",
        icon: {
          name: "fal fa-exclamation-circle mr-xs"
        }
      });
    },
    initUpdateOrder() {
      let vm = this;
      var postURL = `${SERVER_API[ENV]}mflow/OrderMguide/${this.orderId}`;
      fetch(postURL, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "pragma": "no-cache",
          "cache-control": "No-Store",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          t: this.userToken,
          u: this.userID
        }
      })
        .then(res => res.json())
        .then(res => {
          console.log("RESLL ", res);
          if (res.Message && res.Message.indexOf("invalid") > -1) {
            vm.orderError(`Oops.. seems order ${vm.orderId} does not exist.`);
          } else {
            vm.setOrder(res.Order);
          }
        })
        .catch(err => err);
    },
    setOrder(order) {
      console.log("setOrder: ", order);
      this.order = order;
      this.teeth.method = 1;
      if (!order.Order) {
        this.orderError(`Oops.. seems order ${this.orderId} does not exist.`);
        return false;
      }
      this.order.OrderProstheticSolutionIDs = _.filter(
        this.order.OrderProstheticSolutionIDs,
        item => !!item.solution_id
      );
      // if (this.hasMediaFiles) {
      //   this.mediaFileDefaultObj = _.extend(_.clone(order.MediaFiles[0]), {
      //     FileID: -1
      //   });
      // }
      if (this.hasSelectedTeeth) {
        console.log("this.hasSelectedTeeth: ", this.hasSelectedTeeth);
        this.implantLocationDefaultObj = _.extend(
          _.clone(order.ImplantLocations[0]),
          {
            id: -1
          }
        );
        this.teeth.selected = this.order.ImplantLocations.map(tooth => {
          let t = this.fetchToothById(tooth.ThoothID);
          let ADA, FDI;
          if (t) {
            ADA = t.ToothNumberADA;
            FDI = t.ToothNumberFDI;
          }
          return {
            ADA,
            FDI,
            id: tooth.ThoothID,
            opt: tooth.TreatTypeID
          };
        });
      }
      if (this.hasMediaFiles) {
        this.teeth.hasDigital = true;
      }
      if (this.order.Order.MlabStoneModelTrackingNumber) {
        this.teeth.hasStoneModel = true;
      }
      if (this.order.Order.MlabImpressionTrackingNumber) {
        this.teeth.hasImpressions = true;
      }
      if (this.order.Order.File3dTypeID) {
        this.teeth.has3rdParty = true;
      }
    }
  },
  computed: {
    ...mapState({
      locale: state => state.locale,
      orderData: state => state.order.data,
      orderOptions: state => state.order.options
    }),
    ...mapGetters(["userToken", "userID"]),
    getLangDir()
    {
        return this.locale == 'HE' ? 'rtl' : '';
    },
    getFixationPinsText()
    {
      var order = this.order.Order;
      if(order.FixationPins && order.FixationPins==true){
          return this.localize("yes").toUpperCase();
      }else{
          return this.localize("no").toUpperCase();
      }
    },
    serverAPI() {
      return SERVER_API[ENV];
    },
    surgicalPlan() {
      let files = this.order.MediaFiles;
      if (files.length) {
        return _.find(files, { FileType: 9 });
      }
      return null;
    },
    awaitingApproval() {
      return this.order?.StatusID === 21
    },
    hasSelectedTeeth() {
      return !!(
        this.order.ImplantLocations &&
        this.order.ImplantLocations.length &&
        this.order.ImplantLocations[0].ThoothID
      );
    },
    orderFile() {
      let files = this.order.MediaFiles;
      let i = _.findIndex(files, f => f.FileName.indexOf(this.orderId) > -1);
      if (i > -1) {
        return files[i];
      }
      return null;
    },
    uploadedFiles() {
      let files = this.order.MediaFiles;
      if (this.orderFile) {
        return _.filter(files, f => f.FileName !== this.orderFile.FileName);
      }
      return files;
    },
    isUSA() {
      return this.orderUser.Country === "226";
    },
    filteredProstheticSolutionTypes() {
      let d = _.map(this.order.OrderProstheticSolutionIDs, "solution_id");
      // console.log("d >> ", d);
      return _.filter(this.orderOptions.ProstheticSolutionTypes, opt => {
        return d.indexOf(opt.id) > -1;
      });
    },
    orderId() {
      return parseInt(this.$route.params.orderId);
    },
    orderUser() {
      let order = _.keys(this.orderData).length ? this.orderData : this.order;
      if (order.User) {
        return order.User;
      }
      return false;
    },
    hasMediaFiles() {
      let files = this.order.MediaFiles;
      if (files && files.length) {
        return !!files[0].FileName;
      }
      return false;
    },
    hasCBCTFile() {
      let files = this.order.MediaFiles;
      if (files && files.length) {
        let names = _.map(files, "OriginFileName");
        let j = names.join(" ");
        return /(\.zip|\.rar)/g.test(j);
      }
      return false;
    },
    isClinic() {
      if (this.orderUser) {
        return this.orderUser.IsClinic;
      }
      return false;
    },

    implantLocationFields() {
      return [
        {
          id: 1,
          _prop: "num",
          enumerable: true,
          label: this.localize('Tooth'),
          type: "text",
          disabled: true,
          background: "blue",
          color: "gray-0",
          labelColor: "gray-6",
          circle: true,
          css: "mini",
          externalLabel: true
        },
        {
          id: 2,
          _prop: "ToothImplantType",
          label: this.localize('Implant Type'),
          type: "select",
          css: "longer",
          options: this.orderOptions.ImplantTypes,
          rounded: true,
          externalLabel: true,
          required: true
        },
        {
          id: 3,
          _prop: "ToothDiameterType",
          label: this.localize('Diameter'),
          type: "select",
          requires: "ToothImplantType",
          options: this.orderOptions.DiametersTypes,
          rounded: true,
          externalLabel: true
        },
        {
          id: 4,
          _prop: "ToothLengthType",
          label: this.localize('Length'),
          type: "select",
          requires: "ToothDiameterType",
          options: this.orderOptions.LengthTypes,
          rounded: true,
          externalLabel: true
        }
      ];
    }
  }
};
</script>

<style>
  .review-field.rtl span:first-child 
  {
    margin-left: 0.25rem;
    margin-right: inital;
  }

</style>

<style lang="stylus" scoped>
.form-field
  align-items center
  marg('m', bottom)
  .form-part--field
    padding-bottom 0
  *
    flex 1
  label
    font-weight 600
    font-size 14px
    color gray_8
    flex none
    marg('s', right)
  &:at-least(2)
    label
      min-width 120px
  & > :last-child
    color gray_6
</style>
<style lang="stylus" scoped>
.order-form
  &--agree
    padding-right 200px
  &--panels
    border-bottom 1px solid gray_6
.panel
  &--title
    background blue_0
    height 68px
    color gray_9
    font-size 18px
    font-weight 600
    _flex(row, wrap, center, space-between)
    transition background 0.6s ease-out
    cursor pointer
    +desktop()
      &:hover
        background blue_3
    i
      color #fff
      font-size 30px
      transition transform 0.3s ease-out, color 0.3s ease-out, padding-bottom 0.3 ease-out
      will-change transform, color, padding-bottom
  &--content
    _flex(row, wrap, stretch, space-between)
    max-height 100vh
    padding-bottom 30px
    overflow hidden
    transition max-height 0.6s ease-out
    &__half
      flex 0 0 50%
      position relative
      .btn-group.bottom
        position absolute
        width 100%
        bottom 0
      &:first-child
        border-right 1px solid gray_3
        padding-right 40px
      &:last-child
        margin-left 40px
        flex 0 0 calc(50% - 40px)
  &.collapsed
    .panel--title
      background gray_2
      margin-bottom 2px
      box-shadow 1px 1px 0px 0px rgba(0,0,0,0.15)
      i
        transform rotate(-90deg)
        color gray_6
    .panel--content
      max-height 0px
      padding-bottom 0

.bb
  border-bottom 1px solid blue_brand
  pad('m', bottom)

.info-blocks
  width 80%
  max-width 450px
  &--item
    border 1px solid gray_4
    border-radius 6px
    _flex(row, nowrap, center, flex-start)
    pad('m', y)
    pad('xs', right)
    pad('m', left)
    marg('xl', bottom)
    span
      font-size 13px
    &:before
      color #55ABB7
      font-size 24px
      font-weight 600
      margin-right 20px
    &:nth-child(1)
      &:before
        content 'A'
    &:nth-child(2)
      &:before
        content 'B'
    &:nth-child(3)
      &:before
        content 'C'

.link-list li
  margin-bottom 10px
  _flex(row, nowrap, baseline, flex-start )
  i
    font-size 12px
</style>
